/* Sanctuary AI Chatbot v2 — External async asset
 * Loaded via: <script src="{{ 'sanctuary-ai-chatbot.js' | asset_url }}" defer></script>
 * Worker: https://sanctuary-ai.justin-bc1.workers.dev
 * "defer" guarantees DOM is ready before this runs.
 * CSS + HTML are injected immediately; JS logic is deferred to idle time.
 */
(function () {

  // ── 1. INJECT CSS ────────────────────────────────────────────────────────────
  var _style = document.createElement('style');
  _style.textContent = `
#yhs-btn{position:fixed;bottom:28px;right:28px;width:52px;height:52px;background:#F97316;border-radius:50%;border:none;box-shadow:0 4px 20px rgba(249,115,22,.28);cursor:pointer;z-index:2147483640;display:flex;align-items:center;justify-content:center;transition:transform .25s,box-shadow .25s}
#yhs-btn:hover{transform:scale(1.1);box-shadow:0 6px 32px rgba(249,115,22,.55)}
#yhs-btn svg{width:22px;height:22px;fill:none;stroke:#fff;stroke-width:2.2;stroke-linecap:round;stroke-linejoin:round}
#yhs-notif{position:absolute;top:3px;right:3px;width:14px;height:14px;background:#22c55e;border-radius:50%;border:2.5px solid #fff}
#yhs-greet{position:fixed;bottom:106px;right:28px;background:#fff;border-radius:14px 14px 0 14px;box-shadow:0 6px 24px rgba(0,0,0,.13);padding:13px 36px 13px 14px;max-width:230px;z-index:2147483639;opacity:0;transform:translateY(8px);transition:opacity .35s,transform .35s;pointer-events:none;cursor:pointer;font-family:inherit}
#yhs-greet.on{opacity:1;transform:translateY(0);pointer-events:auto}
#yhs-greet-name{font-size:12px;font-weight:700;color:#F97316;margin-bottom:3px}
#yhs-greet-msg{font-size:13px;color:#333;line-height:1.4}
#yhs-greet-x{position:absolute;top:8px;right:10px;font-size:17px;color:#bbb;background:none;border:none;cursor:pointer;line-height:1;padding:0}
#yhs-panel{position:fixed;bottom:106px;right:28px;width:390px;height:580px;background:#fff;border-radius:20px;box-shadow:0 12px 48px rgba(0,0,0,.18);display:flex;flex-direction:column;overflow:hidden;z-index:2147483641;opacity:0;transform:translateY(24px) scale(.96);transition:opacity .28s,transform .28s;pointer-events:none}
#yhs-panel.on{opacity:1;transform:translateY(0) scale(1);pointer-events:auto}
.yhs-hdr{background:linear-gradient(135deg,#F97316,#c2410c);padding:15px 18px;display:flex;align-items:center;gap:11px;flex-shrink:0}
.yhs-av{width:42px;height:42px;border-radius:50%;background:rgba(255,255,255,.2);display:flex;align-items:center;justify-content:center;font-size:21px;flex-shrink:0}
.yhs-hn{color:#fff;font-weight:800;font-size:15px;line-height:1}
.yhs-hs{color:rgba(255,255,255,.85);font-size:12px;display:flex;align-items:center;gap:5px;margin-top:3px}
.yhs-dot{width:7px;height:7px;background:#4ade80;border-radius:50%;flex-shrink:0}
.yhs-hx{margin-left:auto;background:none;border:none;color:rgba(255,255,255,.7);font-size:23px;cursor:pointer;line-height:1;padding:2px 4px;transition:color .2s}
.yhs-hx:hover{color:#fff}
.yhs-chips{padding:10px 14px 7px;display:flex;gap:7px;flex-wrap:wrap;border-bottom:1px solid #f0f0f0;flex-shrink:0;background:#fafafa}
.yhs-chip{background:#fff;border:1.5px solid #e5e7eb;color:#555;font-size:12px;font-weight:600;padding:5px 11px;border-radius:20px;cursor:pointer;white-space:nowrap;transition:all .15s;font-family:inherit}
.yhs-chip:hover{background:#F97316;border-color:#F97316;color:#fff}
.yhs-msgs{flex:1;overflow-y:auto;padding:15px;display:flex;flex-direction:column;gap:12px;scroll-behavior:smooth}
.yhs-msgs::-webkit-scrollbar{width:4px}
.yhs-msgs::-webkit-scrollbar-thumb{background:#e9e9e9;border-radius:2px}
.yhs-msg{display:flex;flex-direction:column;max-width:88%}
.yhs-bot{align-self:flex-start}
.yhs-usr{align-self:flex-end;align-items:flex-end}
.yhs-bbl{padding:11px 14px;border-radius:18px;font-size:14px;line-height:1.55;font-family:inherit}
.yhs-bot .yhs-bbl{background:#f3f4f6;color:#111;border-bottom-left-radius:5px}
.yhs-usr .yhs-bbl{background:#F97316;color:#fff;border-bottom-right-radius:5px}
.yhs-bbl a{color:#F97316;font-weight:600;text-decoration:none}
.yhs-usr .yhs-bbl a{color:rgba(255,255,255,.9)}
.yhs-bbl strong{font-weight:700}
.yhs-bbl ul{margin:7px 0 4px 17px}
.yhs-bbl ul li{margin-bottom:4px}
.yhs-time{font-size:11px;color:#bbb;margin-top:3px;padding:0 4px}
.yhs-usr .yhs-time{text-align:right}
.yhs-typing{padding:12px 14px !important}
.yhs-dots{display:flex;gap:5px;align-items:center}
.yhs-d{width:7px;height:7px;background:#bbb;border-radius:50%;animation:yhsBounce 1.3s infinite ease-in-out}
.yhs-d:nth-child(2){animation-delay:.18s}
.yhs-d:nth-child(3){animation-delay:.36s}
@keyframes yhsBounce{0%,60%,100%{transform:translateY(0);opacity:.5}30%{transform:translateY(-6px);opacity:1}}
.yhs-inp-row{padding:11px 13px;border-top:1px solid #f0f0f0;display:flex;align-items:flex-end;gap:8px;flex-shrink:0;background:#fff}
.yhs-ta{flex:1;border:1.5px solid #e5e7eb;border-radius:12px;padding:9px 13px;font-size:14px;font-family:inherit;resize:none;outline:none;max-height:96px;line-height:1.4;transition:border-color .2s}
.yhs-ta:focus{border-color:#F97316}
.yhs-send{width:40px;height:40px;background:#F97316;border:none;border-radius:11px;cursor:pointer;flex-shrink:0;display:flex;align-items:center;justify-content:center;transition:background .2s}
.yhs-send:hover{background:#ea6c0a}
.yhs-send:disabled{background:#e5e7eb;cursor:not-allowed}
.yhs-send svg{width:17px;height:17px;fill:none;stroke:#fff;stroke-width:2.2;stroke-linecap:round;stroke-linejoin:round}
.yhs-foot{text-align:center;padding:6px;font-size:11px;color:#ccc;background:#fff;flex-shrink:0;font-family:inherit}
.yhs-capture-bbl{background:#fff7ed !important;border:1.5px solid #fed7aa !important;border-bottom-left-radius:5px}
.yhs-cap-inp{width:100%;box-sizing:border-box;border:1.5px solid #e5e7eb;border-radius:8px;padding:7px 10px;font-size:13px;font-family:inherit;outline:none;transition:border-color .2s;margin-bottom:6px;display:block}
.yhs-cap-inp:focus{border-color:#F97316}
.yhs-cap-btn{flex:1;background:#F97316;color:#fff;border:none;border-radius:8px;padding:8px;font-size:13px;font-weight:700;cursor:pointer;font-family:inherit;transition:background .2s}
.yhs-cap-btn:hover{background:#ea6c0a}
.yhs-cap-skip{background:#f3f4f6;color:#888;border:none;border-radius:8px;padding:8px 12px;font-size:13px;cursor:pointer;font-family:inherit;transition:background .2s}
.yhs-cap-skip:hover{background:#e5e7eb}
@media(max-width:460px){#yhs-panel{width:calc(100vw - 16px);right:8px;height:72vh;bottom:90px}#yhs-greet{right:8px}}
  `;
  document.head.appendChild(_style);

  // ── 2. INJECT HTML ───────────────────────────────────────────────────────────
  var _html = document.createElement('div');
  _html.innerHTML = `
<div id="yhs-greet" onclick="yhsOpen()" role="button" aria-label="Open chat">
  <button id="yhs-greet-x" onclick="event.stopPropagation();yhsCloseGreet()" aria-label="Dismiss">×</button>
  <div id="yhs-greet-name">⚡ Sanctuary AI</div>
  <div id="yhs-greet-msg">Recovery question? Ask anything. No forms, instant answers.</div>
</div>

<button id="yhs-btn" onclick="yhsOpen()" aria-label="Open Sanctuary AI chat" aria-expanded="false">
  <svg viewBox="0 0 24 24"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
  <div id="yhs-notif" aria-hidden="true"></div>
</button>

<div id="yhs-panel" role="dialog" aria-modal="true" aria-label="Sanctuary AI Chat" aria-hidden="true">
  <div class="yhs-hdr">
    <div class="yhs-av">⚡</div>
    <div style="flex:1">
      <div class="yhs-hn">Sanctuary AI</div>
      <div class="yhs-hs"><span class="yhs-dot"></span>Live · Expert recovery advisor</div>
    </div>
    <button class="yhs-hx" onclick="yhsClose()" aria-label="Close chat">×</button>
  </div>
  <div class="yhs-chips">
    <button class="yhs-chip" onclick="yhsOpenQuiz()">🎯 Find my device</button>
    <button class="yhs-chip" onclick="yhsQuick('Which compression boots are best for post-surgery recovery?')">🦵 Post-surgery boots</button>
    <button class="yhs-chip" onclick="yhsQuick('Best red light therapy device for face and anti-aging?')">💡 Red light for skin</button>
    <button class="yhs-chip" onclick="yhsQuick('Which massage gun is best for serious athletes?')">💪 Best massage gun</button>
    <button class="yhs-chip" onclick="yhsQuick('What is your return policy?')">📦 Returns &amp; shipping</button>
  </div>
  <div class="yhs-msgs" id="yhs-msgs">
    <div class="yhs-msg yhs-bot">
      <div class="yhs-bbl">Hi! I'm Sanctuary AI. I know every product, policy, and recovery protocol at Your Health Sanctuary. Not sure which device is right for you? <a href="https://yourhealthsanctuary.com/pages/find-your-perfect-recovery-device" target="_blank" rel="noopener" style="color:#F97316;font-weight:700;">Take the 4-question Device Quiz →</a> or ask me anything below.</div>
      <div class="yhs-time">Sanctuary AI · Just now</div>
    </div>
  </div>
  <div class="yhs-inp-row">
    <textarea class="yhs-ta" id="yhs-ta" placeholder="Ask about products, shipping, returns…" rows="1" aria-label="Your message"></textarea>
    <button class="yhs-send" id="yhs-send" aria-label="Send message">
      <svg viewBox="0 0 24 24"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
    </button>
  </div>
  <div class="yhs-foot">Sanctuary AI · Your Health Sanctuary · (612) 360-2490</div>
</div>
  `;
  while (_html.firstChild) {
    document.body.appendChild(_html.firstChild);
  }

  // ── 3. CHATBOT LOGIC (deferred to idle — same as original) ───────────────────
  (window.requestIdleCallback || function (fn, o) { setTimeout(fn, o && o.timeout || 1); })(function () {
    (function () {
      // ── CONFIG ──────────────────────────────────────────────────────────────
      var WORKER_URL = 'https://sanctuary-ai.justin-bc1.workers.dev';

      var isOpen = false, isBusy = false, history = [], initialized = false;
      var botReplyCount = 0;
      var emailCaptureShown = false;

      // ── OPEN / CLOSE ────────────────────────────────────────────────────────
      window.yhsOpen = function () {
        isOpen = true;
        var p = document.getElementById('yhs-panel');
        p.classList.add('on');
        p.setAttribute('aria-hidden', 'false');
        document.getElementById('yhs-btn').setAttribute('aria-expanded', 'true');
        yhsCloseGreet();
        if (!initialized) { initialized = true; }
        setTimeout(function () { document.getElementById('yhs-ta').focus(); }, 300);
      };
      window.yhsClose = function () {
        isOpen = false;
        var p = document.getElementById('yhs-panel');
        p.classList.remove('on');
        p.setAttribute('aria-hidden', 'true');
        document.getElementById('yhs-btn').setAttribute('aria-expanded', 'false');
      };
      window.yhsCloseGreet = function () {
        document.getElementById('yhs-greet').classList.remove('on');
      };

      // ── INPUT ────────────────────────────────────────────────────────────────
      var ta = document.getElementById('yhs-ta');
      var sendBtn = document.getElementById('yhs-send');

      ta.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); yhsSend(); }
      });
      ta.addEventListener('input', function () {
        this.style.height = 'auto';
        this.style.height = Math.min(this.scrollHeight, 96) + 'px';
      });
      sendBtn.addEventListener('click', yhsSend);

      window.yhsQuick = function (text) {
        ta.value = text;
        yhsSend();
      };

      window.yhsOpenQuiz = function () {
        if (!isOpen) yhsOpen();
        addMsg('user', 'Which device is right for me?');
        history.push({ role: 'user', content: 'Which device is right for me?' });
        setTimeout(function () {
          var quizMsg = 'Great question — I built a 4-question quiz for exactly this. It matches you to the right device based on your situation, and Justin reviews every submission personally.\n\n**[Take the Device Quiz →](https://yourhealthsanctuary.com/pages/find-your-perfect-recovery-device)**\n\nOr tell me more about your situation and I\'ll help narrow it down right now.';
          var bubble = addMsg('bot', '');
          bubble.innerHTML = renderMd(quizMsg);
          history.push({ role: 'bot', content: quizMsg });
          botReplyCount++;
          var wrap = document.getElementById('yhs-msgs');
          if (wrap) wrap.scrollTop = wrap.scrollHeight;
        }, 400);
      };

      // ── RENDER ───────────────────────────────────────────────────────────────
      function timeNow() {
        return new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
      }
      function renderMd(text) {
        return text
          .replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank" rel="noopener">$1</a>')
          .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
          .replace(/__(.*?)__/g, '<strong>$1</strong>')
          .replace(/yourhealthsanctuary\.com\/products\/([\w-]+)/g, function (_, h) {
            var label = h.replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
            return '<a href="https://yourhealthsanctuary.com/products/' + h + '" target="_blank" rel="noopener">' + label + ' →</a>';
          })
          .replace(/yourhealthsanctuary\.com\/blogs\/([\w/.-]+)/g, function (_, h) {
            return '<a href="https://yourhealthsanctuary.com/blogs/' + h + '" target="_blank" rel="noopener">Read article →</a>';
          })
          .replace(/\n- (.*?)(?=\n|$)/g, '<li>$1</li>')
          .replace(/(<li>[\s\S]*?<\/li>)/g, '<ul>$1</ul>')
          .replace(/\n{2,}/g, '</p><p>')
          .replace(/\n/g, '<br>');
      }

      function addMsg(role, content) {
        var wrap = document.getElementById('yhs-msgs');
        var div = document.createElement('div');
        div.className = 'yhs-msg ' + (role === 'bot' ? 'yhs-bot' : 'yhs-usr');
        div.innerHTML = '<div class="yhs-bbl">' + renderMd(content) + '</div>'
          + '<div class="yhs-time">' + (role === 'bot' ? 'Sanctuary AI' : 'You') + ' · ' + timeNow() + '</div>';
        wrap.appendChild(div);
        wrap.scrollTop = wrap.scrollHeight;
        return div.querySelector('.yhs-bbl');
      }

      function showTyping() {
        var wrap = document.getElementById('yhs-msgs');
        var div = document.createElement('div');
        div.id = 'yhs-typing';
        div.className = 'yhs-msg yhs-bot';
        div.innerHTML = '<div class="yhs-bbl yhs-typing"><div class="yhs-dots"><div class="yhs-d"></div><div class="yhs-d"></div><div class="yhs-d"></div></div></div>';
        wrap.appendChild(div);
        wrap.scrollTop = wrap.scrollHeight;
      }
      function hideTyping() {
        var el = document.getElementById('yhs-typing');
        if (el) el.remove();
      }
      function resetSend() {
        isBusy = false;
        sendBtn.disabled = false;
        ta.focus();
      }

      // ── EMAIL CAPTURE ────────────────────────────────────────────────────────
      function maybeShowEmailCapture() {
        if (emailCaptureShown || botReplyCount < 2) return;
        emailCaptureShown = true;
        setTimeout(function () {
          var wrap = document.getElementById('yhs-msgs');
          if (!wrap) return;
          var div = document.createElement('div');
          div.id = 'yhs-capture';
          div.className = 'yhs-msg yhs-bot';
          div.innerHTML = ''
            + '<div class="yhs-bbl yhs-capture-bbl">'
            + '<div style="font-size:13px;font-weight:700;color:#92400e;margin-bottom:6px">💬 Want a personal follow-up from Justin?</div>'
            + '<div style="font-size:13px;color:#78350f;margin-bottom:10px;line-height:1.45">Drop your info and he\'ll reach out directly — no spam, ever.</div>'
            + '<input id="yhs-cap-name" class="yhs-cap-inp" type="text" placeholder="Your name" autocomplete="name">'
            + '<input id="yhs-cap-email" class="yhs-cap-inp" type="email" placeholder="Email address" autocomplete="email">'
            + '<div style="display:flex;gap:8px">'
            + '<button class="yhs-cap-btn" onclick="yhsSubmitLead()">Notify me →</button>'
            + '<button class="yhs-cap-skip" onclick="document.getElementById(\'yhs-capture\').remove()">Maybe later</button>'
            + '</div>'
            + '</div>'
            + '<div class="yhs-time">Sanctuary AI · ' + timeNow() + '</div>';
          wrap.appendChild(div);
          wrap.scrollTop = wrap.scrollHeight;
        }, 600);
      }

      window.yhsSubmitLead = function () {
        var nameEl = document.getElementById('yhs-cap-name');
        var emailEl = document.getElementById('yhs-cap-email');
        var name = nameEl ? nameEl.value.trim() : '';
        var email = emailEl ? emailEl.value.trim() : '';

        if (!email || !email.includes('@')) {
          if (emailEl) { emailEl.style.borderColor = '#F97316'; emailEl.focus(); }
          return;
        }

        var capture = document.getElementById('yhs-capture');
        if (capture) {
          capture.querySelector('.yhs-bbl').innerHTML =
            '<div style="font-size:14px;color:#166534">✅ Got it! Justin will be in touch at <strong>' + email + '</strong>.</div>';
        }

        var chatLines = history.slice(-8).map(function (m) {
          return (m.role === 'bot' ? 'Sanctuary AI' : 'Visitor') + ': ' + m.content;
        }).join('\n');

        fetch(WORKER_URL + '/lead', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ name: name, email: email, chat: chatLines })
        }).catch(function () {});
      };

      // ── SEND (STREAMING) ──────────────────────────────────────────────────────
      function yhsSend() {
        var text = ta.value.trim();
        if (!text || isBusy) return;
        ta.value = '';
        ta.style.height = 'auto';
        isBusy = true;
        sendBtn.disabled = true;

        addMsg('user', text);
        history.push({ role: 'user', content: text });
        showTyping();

        var quizTriggers = ['which device', 'not sure which', 'help me choose', 'what should i get', 'which product', 'best for me', 'right for me', 'what do you recommend', 'what device', 'help choose', 'unsure which'];
        var lowerText = text.toLowerCase();
        if (quizTriggers.some(function (p) { return lowerText.indexOf(p) !== -1; })) {
          hideTyping();
          var qMsg = 'It sounds like you need a personalized match! Our 4-question quiz is built for exactly this:\n\n**[Take the Device Quiz →](https://yourhealthsanctuary.com/pages/find-your-perfect-recovery-device)**\n\nJustin reviews every submission personally and follows up directly. Takes under a minute.';
          var bubble = addMsg('bot', '');
          bubble.innerHTML = renderMd(qMsg);
          history.push({ role: 'bot', content: qMsg });
          botReplyCount++;
          resetSend();
          maybeShowEmailCapture();
          return;
        }

        var messages = history.map(function (m) {
          return { role: m.role === 'bot' ? 'assistant' : 'user', content: m.content };
        });

        fetch(WORKER_URL + '/chat', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ messages: messages, stream: true })
        })
          .then(function (res) {
            if (!res.ok || !res.body) throw new Error('Network error');

            hideTyping();

            var bubble = addMsg('bot', '');
            var fullText = '';
            var buffer = '';
            var decoder = new TextDecoder();
            var reader = res.body.getReader();

            function readChunk() {
              reader.read().then(function (result) {
                if (result.done) {
                  history.push({ role: 'bot', content: fullText });
                  botReplyCount++;
                  resetSend();
                  maybeShowEmailCapture();
                  return;
                }

                buffer += decoder.decode(result.value, { stream: true });
                var lines = buffer.split('\n');
                buffer = lines.pop();

                for (var i = 0; i < lines.length; i++) {
                  var line = lines[i].trim();
                  if (!line.startsWith('data: ')) continue;
                  var jsonStr = line.slice(6);
                  if (jsonStr === '[DONE]') continue;
                  try {
                    var evt = JSON.parse(jsonStr);
                    if (
                      evt.type === 'content_block_delta' &&
                      evt.delta &&
                      evt.delta.type === 'text_delta' &&
                      evt.delta.text
                    ) {
                      fullText += evt.delta.text;
                      bubble.innerHTML = renderMd(fullText);
                      var wrap = document.getElementById('yhs-msgs');
                      if (wrap) wrap.scrollTop = wrap.scrollHeight;
                    }
                  } catch (e) {
                    // Ignore malformed SSE lines
                  }
                }

                readChunk();
              }).catch(function () {
                hideTyping();
                addMsg('bot', 'I lost the connection mid-reply. Please try again or call us at (612) 360-2490.');
                resetSend();
              });
            }

            readChunk();
          })
          .catch(function () {
            hideTyping();
            addMsg('bot', 'I\'m having trouble connecting. Please call us at (612) 360-2490 or email support@yourhealthsanctuary.com — we\'re here Mon–Sat 9am–6pm.');
            resetSend();
          });
      }

      // ── GREETING (shows after 15 seconds if chat hasn't been opened) ──────────
      setTimeout(function () {
        if (!isOpen) document.getElementById('yhs-greet').classList.add('on');
      }, 15000);

    })();
  }, { timeout: 2000 });

})();
